'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.performLayerAction = exports.initializeKmap = exports.panBy = exports.goToGPS = exports.goToAddress = exports.reloadLayer = exports.goToBounds = exports.goToOverview = exports.deleteAllSpecialMarkers = exports.goToPoint = exports.initializeKmapSuccess = exports.selectElement = exports.getView = exports.setView = exports.setZoomLevel = exports.setLayerVisibility = exports.setLayerParams = exports.layerRegisterEvent = exports.registerMapEvent = exports.removeLayer = exports.loadLayer = exports.searchAddress = exports.SEARCH_ADDRESS_FAILURE = exports.SEARCH_ADDRESS_SUCCESS = exports.SEARCH_ADDRESS_REQUEST = exports.INITIALIZE_KMAP_FAILURE = exports.INITIALIZE_KMAP_SUCCESS = exports.INITIALIZE_KMAP_REQUEST = exports.PAN_BY = exports.CLEAR_MARKER = exports.GO_TO_BOUNDS = exports.CLEAR_SPECIAL_MARKER = exports.GO_TO_GPS = exports.GO_TO_POINT = exports.GO_TO_ADDRESS = exports.REMOVE_SELECTED_ELEMENT = exports.SELECT_ELEMENT = exports.REMOVE_LAYER = exports.RELOAD_LAYER = exports.LOAD_LAYER = exports.SET_VIEW = exports.GET_VIEW = exports.SET_CENTER = exports.SET_LAYER_PARAMS = exports.SET_MAP_TYPE = exports.STOP_LAYER_ANIMATION = exports.START_LAYER_ANIMATION = exports.SET_KMAP_ZOOM_LEVEL = exports.REGISTER_MAP_EVENT = exports.LAYER_REGISTER_EVENT = exports.SET_LAYER_VISIBILITY = exports.GO_TO_OVERVIEW = exports.KMAP_API = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _isUndefined2 = require('lodash/isUndefined');

var _isUndefined3 = _interopRequireDefault(_isUndefined2);

exports.setMapType = setMapType;
exports.setCenter = setCenter;
exports.removeSelected = removeSelected;
exports.startLayerAnimation = startLayerAnimation;
exports.stopLayerAnimation = stopLayerAnimation;

var _kubraKmap = require('kubra-kmap');

var _kubraKmap2 = _interopRequireDefault(_kubraKmap);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * KMap actions generally interact with the map instance, and then pass on a
 * normal action object so that the other middleware and reducers
 * know what has happened
 */


var KMAP_API = exports.KMAP_API = 'KMAP';
var GO_TO_OVERVIEW = exports.GO_TO_OVERVIEW = 'GO_TO_OVERVIEW';
var SET_LAYER_VISIBILITY = exports.SET_LAYER_VISIBILITY = 'SET_LAYER_VISIBILITY';
var LAYER_REGISTER_EVENT = exports.LAYER_REGISTER_EVENT = 'LAYER_REGISTER_EVENT';
var REGISTER_MAP_EVENT = exports.REGISTER_MAP_EVENT = 'REGISTER_MAP_EVENT';
var SET_KMAP_ZOOM_LEVEL = exports.SET_KMAP_ZOOM_LEVEL = 'SET_KMAP_ZOOM_LEVEL';
var START_LAYER_ANIMATION = exports.START_LAYER_ANIMATION = 'START_LAYER_ANIMATION';
var STOP_LAYER_ANIMATION = exports.STOP_LAYER_ANIMATION = 'STOP_LAYER_ANIMATION';
var SET_MAP_TYPE = exports.SET_MAP_TYPE = 'SET_MAP_TYPE';
var SET_LAYER_PARAMS = exports.SET_LAYER_PARAMS = 'SET_LAYER_PARAMS';
var SET_CENTER = exports.SET_CENTER = 'SET_CENTER';
var GET_VIEW = exports.GET_VIEW = 'GET_VIEW';
var SET_VIEW = exports.SET_VIEW = 'SET_VIEW';
var LOAD_LAYER = exports.LOAD_LAYER = 'LOAD_LAYER';
var RELOAD_LAYER = exports.RELOAD_LAYER = 'RELOAD_LAYER';
var REMOVE_LAYER = exports.REMOVE_LAYER = 'REMOVE_LAYER';
var SELECT_ELEMENT = exports.SELECT_ELEMENT = 'SELECT_ELEMENT';
var REMOVE_SELECTED_ELEMENT = exports.REMOVE_SELECTED_ELEMENT = 'REMOVE_SELECTED_ELEMENT';
var GO_TO_ADDRESS = exports.GO_TO_ADDRESS = 'GO_TO_ADDRESS';
var GO_TO_POINT = exports.GO_TO_POINT = 'GO_TO_POINT';
var GO_TO_GPS = exports.GO_TO_GPS = 'GO_TO_GPS';
var CLEAR_SPECIAL_MARKER = exports.CLEAR_SPECIAL_MARKER = 'CLEAR_SPECIAL_MARKER';
var GO_TO_BOUNDS = exports.GO_TO_BOUNDS = 'GO_TO_BOUNDS';
var CLEAR_MARKER = exports.CLEAR_MARKER = 'CLEAR_MARKER';
var PAN_BY = exports.PAN_BY = 'PAN_BY';
var INITIALIZE_KMAP_REQUEST = exports.INITIALIZE_KMAP_REQUEST = 'INITIALIZE_KMAP_REQUEST';
var INITIALIZE_KMAP_SUCCESS = exports.INITIALIZE_KMAP_SUCCESS = 'INITIALIZE_KMAP_SUCCESS';
var INITIALIZE_KMAP_FAILURE = exports.INITIALIZE_KMAP_FAILURE = 'INITIALIZE_KMAP_FAILURE';
var SEARCH_ADDRESS_REQUEST = exports.SEARCH_ADDRESS_REQUEST = 'SEARCH_ADDRESS_REQUEST';
var SEARCH_ADDRESS_SUCCESS = exports.SEARCH_ADDRESS_SUCCESS = 'SEARCH_ADDRESS_SUCCESS';
var SEARCH_ADDRESS_FAILURE = exports.SEARCH_ADDRESS_FAILURE = 'SEARCH_ADDRESS_FAILURE';
/*
const messages = defineMessages({
  address: {
    id: 'client.address',
    defaultMessage: 'Address',
  },
  youStartedHere: {
    id: 'client.gps.youStartedHere',
    defaultMessage: 'You Started Here',
  },
  errorAddressOutside: {
    id: 'client.gps.errorAddressOutside',
    defaultMessage: 'Address is outside the valid area',
  },
  errorLocationOutside: {
    id: 'client.gps.errorLocationOutside',
    defaultMessage: 'Location is outside the valid area',
  },
  errorAddressNotFound: {
    id: 'client.gps.addressNotFound',
    defaultMessage: 'Address Not found',
  },
  errorAddressSearchFailed: {
    id: 'client.address.errorAddressSearchFailed',
    defaultMessage: 'Address Search failed',
  },
  errorLatLngNotFound: {
    id: 'client.gps.errorLatLngNotFound',
    defaultMessage: 'Invalid latitude or longitude provided',
  },
  invalidErrorCode: {
    id: 'client.kmap.invalidErrorCode',
    defaultMessage: 'Unknown error occurred',
  },
});
*/

var searchAddress = exports.searchAddress = function searchAddress(address) {
  return function (dispatch) {
    return new _promise2.default(function (resolve) {
      dispatch((0, _defineProperty3.default)({}, KMAP_API, function (kmapInstance) {
        kmapInstance.searchAddress(address).then(function (data) {
          dispatch({
            type: SEARCH_ADDRESS_SUCCESS
          });
          resolve(data);
        }).catch(function () {
          dispatch({
            type: SEARCH_ADDRESS_FAILURE
          });
        });
        return {
          type: SEARCH_ADDRESS_REQUEST
        };
      }));
    });
  };
};
/**
 * Load a layer onto the map
 * @param {*} layerName the name of the layer to load
 * @param {*} source the data source for the layer
 * @param {*} properties the layer properties
 */

/**
 * Load a layer onto the map
 * @param {*} layerName the name of the layer to load
 * @param {*} source the data source for the layer
 * @param {*} properties the layer properties
 */


var loadLayer = exports.loadLayer = function loadLayer(layerName, source, properties) {
  return function (dispatch) {
    return dispatch((0, _defineProperty3.default)({}, KMAP_API, function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(kmapInstance) {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', kmapInstance.loadLayer(layerName, source, properties).then(function () {
                  dispatch({
                    type: LOAD_LAYER,
                    layerName: layerName,
                    source: source,
                    properties: properties
                  });
                }));

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, undefined);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()));
  };
};
/**
 * Remove a layer onto the map
 * @param {*} layerName the name of the layer to load
 */


var removeLayer = exports.removeLayer = function removeLayer(layerName) {
  return (0, _defineProperty3.default)({}, KMAP_API, function (kmapInstance) {
    kmapInstance.removeLayer(layerName);
    return {
      type: REMOVE_LAYER,
      layerName: layerName
    };
  });
};
/**
 * Register an event handler for a map event
 * @param {*} event the event constant from kmap library
 * @param {*} callback the function to execute
 */


var registerMapEvent = exports.registerMapEvent = function registerMapEvent(event, callback) {
  return (0, _defineProperty3.default)({}, KMAP_API, function (kmapInstance) {
    kmapInstance.on(event, callback);
    return {
      type: REGISTER_MAP_EVENT
    };
  });
};
/**
 * Regsiter an event handler for a layer event
 * @param {*} layerName the name of the layer
 * @param {*} event the event constant from kmap library
 * @param {*} callback the function to execute
 */


var layerRegisterEvent = exports.layerRegisterEvent = function layerRegisterEvent(layerName, event, callback) {
  return (0, _defineProperty3.default)({}, KMAP_API, function (kmapInstance) {
    kmapInstance.layerRegisterEvent(layerName, event, callback);
    return {
      type: LAYER_REGISTER_EVENT
    };
  });
};
/**
 * Set the paramters on a layer
 * @param {*} layerName the name of the layer
 * @param (*) layerCategory to identify the layer category.
 * @param {*} params the layer parameters
 */


var setLayerParams = exports.setLayerParams = function setLayerParams(layerName, params, layerCategory) {
  return (0, _defineProperty3.default)({}, KMAP_API, function (kmapInstance) {
    try {
      kmapInstance.setLayerParams(layerName, params);
    } catch (e) {// console.warn(e);
    }

    return {
      type: SET_LAYER_PARAMS,
      layerName: layerName,
      layerCategory: layerCategory,
      params: params
    };
  });
};
/**
 * Set the visibility of a layer
 * @param {*} layerName
 * @param {*} visible
 */


var setLayerVisibility = exports.setLayerVisibility = function setLayerVisibility(layerName, layerCategory, visible) {
  return (0, _defineProperty3.default)({}, KMAP_API, function (kmapInstance) {
    kmapInstance.setLayerVisibility(layerName, visible);
    return {
      type: SET_LAYER_VISIBILITY,
      layerName: layerName,
      layerCategory: layerCategory,
      visible: visible
    };
  });
};
/**
 * Set the zoom level on the kmap instance
 * @param {*} zoomLevel
 */


var setZoomLevel = exports.setZoomLevel = function setZoomLevel(zoomLevel) {
  return (0, _defineProperty3.default)({}, KMAP_API, function (kmapInstance) {
    kmapInstance.setZoom(zoomLevel);
    return {
      type: SET_KMAP_ZOOM_LEVEL,
      zoomLevel: zoomLevel
    };
  });
};
/**
 * Sets the map type (satellite, road, etc)
 * @param {*} id the value as it appears on the selected option (satellite, road)
 */


function setMapType(mapType) {
  return (0, _defineProperty3.default)({}, KMAP_API, function (kmapInstance) {
    kmapInstance.setMapType(mapType);
    return {
      type: SET_MAP_TYPE,
      mapType: mapType
    };
  });
}

function setCenter(latLng) {
  return (0, _defineProperty3.default)({}, KMAP_API, function (kmapInstance) {
    kmapInstance.setCenter(latLng);
    return {
      type: SET_CENTER,
      latLng: latLng
    };
  });
}

var setView = exports.setView = function setView(viewObj) {
  return (0, _defineProperty3.default)({}, KMAP_API, function (kmapInstance) {
    kmapInstance.setView(viewObj);
    return {
      type: SET_VIEW,
      viewObj: viewObj
    };
  });
};

var getView = exports.getView = function getView() {
  return (0, _defineProperty3.default)({}, KMAP_API, function (kmapInstance) {
    var view = kmapInstance.getView();
    return {
      type: GET_VIEW,
      view: view
    };
  });
};

var selectElement = exports.selectElement = function selectElement(geom, type) {
  return function (dispatch) {
    return dispatch((0, _defineProperty3.default)({}, KMAP_API, function () {
      var _ref12 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(kmapInstance) {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt('return', kmapInstance.selectElement(geom, type));

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, undefined);
      }));

      return function (_x2) {
        return _ref12.apply(this, arguments);
      };
    }()));
  };
};

function removeSelected() {
  var isMulti = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var geom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return (0, _defineProperty3.default)({}, KMAP_API, function (kmapInstance) {
    kmapInstance.removeSelected(isMulti, geom);
    return {
      type: REMOVE_SELECTED_ELEMENT
    };
  });
}
/**
 * Start Layer Animation
 * @param {*} layerName the name of the layer
 */


function startLayerAnimation(layerName) {
  return (0, _defineProperty3.default)({}, KMAP_API, function (kmapInstance) {
    kmapInstance.startLayerAnimation(layerName);
    return {
      type: START_LAYER_ANIMATION,
      layerName: layerName
    };
  });
}
/**
 * Stop Layer Animation
 * @param {*} layerName the layer name
 */


function stopLayerAnimation(layerName) {
  return (0, _defineProperty3.default)({}, KMAP_API, function (kmapInstance) {
    kmapInstance.stopLayerAnimation(layerName);
    return {
      type: STOP_LAYER_ANIMATION,
      layerName: layerName
    };
  });
}
/**
 * Initialize the map
 */


var initializeKmapSuccess = exports.initializeKmapSuccess = function initializeKmapSuccess(kmap) {
  return (0, _defineProperty3.default)({}, KMAP_API, {
    type: INITIALIZE_KMAP_SUCCESS,
    kmap: kmap
  });
};
/**
 *
 * @param {*} view
 * @param {*} markerType
 * @param {*} extraProp
 * @param {*} resultHandler
 */


var goToPoint = exports.goToPoint = function goToPoint(view) {
  var markerType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _kubraKmap2.default.specialMarker.ADDRESS;
  var extraProp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var resultHandler = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};
  return (0, _defineProperty3.default)({}, KMAP_API, function (kmapInstance) {
    kmapInstance.goToPoint(view, markerType, extraProp).then(function (result) {
      // pass the result to the handler
      resultHandler(result);
    });
    return {
      type: GO_TO_POINT,
      view: view,
      markerType: markerType,
      extraProp: extraProp
    };
  });
};

var deleteAllSpecialMarkers = exports.deleteAllSpecialMarkers = function deleteAllSpecialMarkers() {
  return function (dispatch) {
    return dispatch((0, _defineProperty3.default)({}, KMAP_API, function (kmapInstance) {
      kmapInstance.deleteAllSpecialMarkers();
      return {
        type: CLEAR_SPECIAL_MARKER
      };
    }));
  };
};
/**
 * Move the map to the preset overview coordinates
 */


var goToOverview = exports.goToOverview = function goToOverview() {
  return function (dispatch) {
    return dispatch((0, _defineProperty3.default)({}, KMAP_API, function (kmapInstance) {
      kmapInstance.goToOverview();
      return {
        type: GO_TO_OVERVIEW
      };
    }));
  };
};

var goToBounds = exports.goToBounds = function goToBounds(bounds) {
  return function (dispatch) {
    return dispatch((0, _defineProperty3.default)({}, KMAP_API, function (kmapInstance) {
      kmapInstance.setBBox(bounds);
      return {
        type: GO_TO_BOUNDS
      };
    }));
  };
};

var reloadLayer = exports.reloadLayer = function reloadLayer(layerName) {
  return function (dispatch) {
    return dispatch((0, _defineProperty3.default)({}, KMAP_API, function (kmapInstance) {
      kmapInstance.reloadLayer(layerName);
      return {
        type: RELOAD_LAYER
      };
    }));
  };
};

var goToAddress = exports.goToAddress = function goToAddress(address) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (dispatch) {
    return dispatch((0, _defineProperty3.default)({}, KMAP_API, function () {
      var _ref18 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(kmapInstance) {
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt('return', kmapInstance.goToAddress(address, options.mapZoom, options.markerType));

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, undefined);
      }));

      return function (_x9) {
        return _ref18.apply(this, arguments);
      };
    }()));
  };
};

var goToGPS = exports.goToGPS = function goToGPS(view) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (dispatch) {
    return dispatch((0, _defineProperty3.default)({}, KMAP_API, function () {
      var _ref19 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(kmapInstance) {
        var useMarker;
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                // if marker is not defined we default to GPS
                useMarker = (0, _isUndefined3.default)(options.marker) ? _kubraKmap2.default.specialMarker.GPS : options.marker;
                return _context4.abrupt('return', kmapInstance.goToPoint(view, useMarker, options.extraProps));

              case 2:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, undefined);
      }));

      return function (_x11) {
        return _ref19.apply(this, arguments);
      };
    }()));
  };
};

var panBy = exports.panBy = function panBy(offsetX, offsetY) {
  return (0, _defineProperty3.default)({}, KMAP_API, function (kmapInstance) {
    kmapInstance.panBy(offsetX, offsetY);
    return {
      type: PAN_BY,
      offsetX: offsetX,
      offsetY: offsetY
    };
  });
};

var initializeKmap = exports.initializeKmap = function initializeKmap(kmapProperties) {
  return function (dispatch) {
    return new _promise2.default(function (resolve, reject) {
      // on initialize map action we create a map..
      dispatch({
        type: INITIALIZE_KMAP_REQUEST
      });

      try {
        _kubraKmap2.default.createMap((0, _extends3.default)({}, kmapProperties, {
          id: 'map'
        })).then(function (mapObj) {
          var _dispatch10; // set the local map instance


          var kmapInstance = mapObj;
          dispatch((_dispatch10 = {}, (0, _defineProperty3.default)(_dispatch10, KMAP_API, {
            type: INITIALIZE_KMAP_SUCCESS
          }), (0, _defineProperty3.default)(_dispatch10, 'kmap', kmapInstance), _dispatch10));
          resolve(kmapInstance);
        });
      } catch (e) {
        dispatch({
          type: INITIALIZE_KMAP_FAILURE,
          error: e
        });
        reject(e);
      }
    });
  };
};

var performLayerAction = exports.performLayerAction = function performLayerAction(functionName, layerName) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  return (0, _defineProperty3.default)({}, KMAP_API, function (kmapInstance) {
    kmapInstance.layerDispatch.apply(kmapInstance, [functionName, layerName].concat(args));
    return {
      type: 'PERFORM_LAYER_DISPATCH'
    };
  });
};

exports.default = {
  searchAddress: searchAddress,
  loadLayer: loadLayer,
  removeLayer: removeLayer,
  registerMapEvent: registerMapEvent,
  layerRegisterEvent: layerRegisterEvent,
  setLayerParams: setLayerParams,
  setLayerVisibility: setLayerVisibility,
  setZoomLevel: setZoomLevel,
  setMapType: setMapType,
  setCenter: setCenter,
  setView: setView,
  getView: getView,
  selectElement: selectElement,
  removeSelected: removeSelected,
  startLayerAnimation: startLayerAnimation,
  stopLayerAnimation: stopLayerAnimation,
  initializeKmapSuccess: initializeKmapSuccess,
  goToPoint: goToPoint,
  deleteAllSpecialMarkers: deleteAllSpecialMarkers,
  goToOverview: goToOverview,
  goToBounds: goToBounds,
  reloadLayer: reloadLayer,
  goToAddress: goToAddress,
  goToGPS: goToGPS,
  panBy: panBy,
  initializeKmap: initializeKmap,
  performLayerAction: performLayerAction
};